import { useCallback, useEffect, useRef } from 'react'
import { NeoniApi } from '../lib/api'
import useAddNotification from './useAddNotification'

function useInterruptibleMutation(api: NeoniApi, key: string | undefined, warning: string) {
	const notify = useAddNotification()
	const notifyRef = useRef(notify)
	const warningRef = useRef(warning)
	const pending = useRef<{ controller: AbortController; submitted: boolean }>()
	notifyRef.current = notify
	warningRef.current = warning

	const abort = useCallback(() => {
		const request = pending.current
		if (!request) return
		pending.current = undefined
		request.controller.abort()
		if (request.submitted) notifyRef.current({ body: warningRef.current })
	}, [])

	useEffect(() => abort, [api, key, abort])

	return () => {
		abort()
		const request = { controller: new AbortController(), submitted: false }
		pending.current = request
		return {
			signal: request.controller.signal,
			onSubmitted: () => { request.submitted = true },
			finish: () => {
				if (pending.current === request) pending.current = undefined
			},
		}
	}
}

export default useInterruptibleMutation
